<template>
  <section>
    <h1 class="push-down-20">WELCOME</h1>
    <p>THANKS FOR JOINING US ON THIS JOURNEY</p>
    <p>CHECK OUT THE LINKS BELOW TO GET STARTED!</p>
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-6">
          <HowToRux />
        </div>
        <div class="col-12 col-sm-6">
          <ViewAllRux />
        </div>
        <div class="col-12 col-sm-6">
          <UpgradeYourRux />
        </div>
        <div class="col-12 col-sm-6">
          <ReferAFriend />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import HowToRux from './cards/HowToRux'
import ViewAllRux from './cards/ViewAllRux'
import UpgradeYourRux from './cards/UpgradeYourRux'
import ReferAFriend from './cards/ReferAFriend'

export default {
  name: 'Register',
  components: {
    HowToRux,
    ViewAllRux,
    UpgradeYourRux,
    ReferAFriend,
  },
}
</script>
